import React from 'react';
import './Contact.css';
import rubel1 from '../../assets/rubel2.jpeg';
import CalenderSchedule from './CalenderSchedule/CalenderSchedule';

const Contact = () => {
  return (
    <section id="contact" className="about-me-container mt-16 md:mt-16">
      <div className="flex justify-center ">
        <h2 className="text-white mb-5 md:mb-0 font-extrabold text-4xl relative z-20  ">
          CONTACT ME.
        </h2>
        <svg
          class="absolute mt-[20px]"
          width="175"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="pathItem"
            d="M5 20 Q 70 0 150 20"
            stroke="#E12457"
            fill="transparent"
            stroke-width="7"
            stroke-linecap="round"
          ></path>
        </svg>
      </div>

      <div className="about-me-content duration-1000 mt-5 md:mt-10">
        <div className="about-me-avatar">
          <img src={rubel1} alt="" />
          <pre className="text-primary mt-5">
            Also You can reach out me: <br />
            Phone: +88 01917-505474 <br />
            Email: phrubel42@gmail.com <br />
            dev.rubel42@gmail.com
          </pre>
        </div>
        <div className="mt-5 md:mt-10 ">
          <CalenderSchedule />
        </div>
      </div>
    </section>
  );
};

export default Contact;
